import _ from "lodash";
import {__} from "./__";

export const getAiFileTools = (tools) => _.reduce(tools, (result, tool) => {
    let toolText = tool;

    switch (tool) {
        case 'file_search':
            toolText = __('Základné spracovanie, AI si vyberie časti prílohy ktoré uzná za vhodné - nízka cena');
            break;

        case 'code_interpreter':
            toolText = __('Komplexné spracovanie, AI prejde a zanalyzuje všetky dáta v prílohe - vyššia cena');
            break;
    }

    return { ...result, [tool]: toolText };
}, {});
